import * as React from "react";
import { BlurbPara } from "../Layouts/Blurb/BlurbStyles";

export const generateBlurb = (blurbParas: string[]) => {
	const returnValue = blurbParas.map((para: string) => {
		const innerReturnValue = (
			<BlurbPara>
				{para}
			</BlurbPara>
		);
		return innerReturnValue
	});
	return returnValue;
}
